import React, { useState,useEffect } from "react";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import { getSearchGooglePlaces } from "../../../utils/reviewApi";

const SourceTab = ({updateReviewTabData,reviewTabData}) => {
    const [businessName, setBusinessName] = useState(reviewTabData.business_name || "");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchSourceTabClicked, setSearchSourceTabClicked] = useState(false);
    const [apiGooglePlaceData, setGooglePlaceApiData] = useState(null);

    // Sync with latest business_name from props
    useEffect(() => {
        setBusinessName(reviewTabData.business_name || "");
    }, [reviewTabData.business_name]);

    // State to manage the submission status
    const submitReviewForm = async (e) => {
        e.preventDefault();

        if (!businessName.trim()) {
            toast.error("Please enter business name or address...");
            return;
        }
        //Chnage the state of isSubmitting to true
        setIsSubmitting(true);
        setSearchSourceTabClicked(true);
        setLoading(true);
        setGooglePlaceApiData(null); 

        //Try to get the data from google places API
        try {
            //Call the function to get the data from google places API
            const result = await getSearchGooglePlaces(businessName);
            if (!result?.data?.length) {
                toast.error("No results found.");
            }
            //Set the state of apiGooglePlaceData with the result
            setGooglePlaceApiData(result);
            setIsSubmitting(false);
        } catch (error) {
            toast.error(error.message || "An error occurred while fetching data.");
            setGooglePlaceApiData(null);
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    // Handle selecting Source Tab Result
    const handleSourceTabSelectResult = async (place) => {
        setBusinessName(place.name);
        setSearchSourceTabClicked(false);
        //Update and chnage the state of isSubmitting to true
        updateReviewTabData("business_name", place.name); 
    };

    return (
        <div className="side-baar-inner-source">
            <span>Source</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        placeholder="Enter business name or address..."
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={submitReviewForm}
                        disabled={isSubmitting}
                        className={isSubmitting ? "disabled" : ""}
                    >
                        {isSubmitting ? "Searching..." : "Search"}
                    </button>
                    
                    {/* Display search results or loading message */}
                    {searchSourceTabClicked && (
                        <ul className="search-results">
                            {loading && <li>Loading results...</li>}

                            {!loading && Array.isArray(apiGooglePlaceData?.data) && apiGooglePlaceData.data.length > 0 && (
                            apiGooglePlaceData.data.map((place, index) => (
                                <li key={index} onClick={() => handleSourceTabSelectResult(place)}>
                                <strong>{place.name}</strong> - {place.address}
                                </li>
                            ))
                            )}

                            {!loading && (!apiGooglePlaceData || !Array.isArray(apiGooglePlaceData.data) || apiGooglePlaceData.data.length === 0) && (
                                <li>No results found.</li>
                            )}
                        </ul>
                    )}
                </div>
            </div>
            <p>
                Enter your business name and address (city, street, zip, etc.). For example:  
                <strong>"Brooklyn Museum, New York, 200 Eastern Pkwy"</strong>
            </p>
            <p>
                Or use a Google Maps link if no physical address is available. For Example:  
                <a href="https://maps.app.goo.gl/YdDK8Lu5Jozk2ow36" target="_blank" rel="noopener noreferrer">
                    Google Maps Link
                </a>
            </p>
            <p>
                For more details, see our article on  
                <Link to="/"> how to set a Google location for displaying reviews.</Link>
            </p>
        </div>
    );
};

export default SourceTab;
